import { g as l } from "../../utils-BOfnFgIH.js";
import { I as o } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as s, normalizeClass as d, createElementVNode as e } from "vue";
import { _ as u } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconZoom",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (a) => Object.keys(o).includes(a)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return o[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded"), this.uniqueID = l();
  }
}, f = ["aria-label", "data-qa", "aria-hidden"], m = ["fill"], p = ["id"];
function _(a, t, r, h, g, i) {
  return n(), s("svg", {
    "aria-label": r.ariaLabel,
    class: d([i.iconSizeClass, "d-icon d-icon--zoom"]),
    "data-qa": i.dataQA,
    "aria-hidden": i.ariaHidden,
    role: "img",
    "data-name": "Zoom",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    e("rect", {
      x: "2",
      y: "2",
      width: "20",
      height: "20",
      rx: "6",
      fill: `url(#${a.uniqueID}a)`
    }, null, 8, m),
    t[1] || (t[1] = e("path", {
      d: "M7 8.563a.625.625 0 0 0-.625.624v4.027c0 1.036.84 1.875 1.875 1.875h5.807c.345 0 .625-.28.625-.625v-4.027c0-1.035-.84-1.874-1.875-1.874H7Zm8.495 1.622a.625.625 0 0 0-.22.476v2.627c0 .183.08.357.22.476l1.568 1.337a.625.625 0 0 0 1.03-.476V9.323a.625.625 0 0 0-1.03-.475l-1.568 1.337Z",
      fill: "#fff"
    }, null, -1)),
    e("defs", null, [
      e("linearGradient", {
        id: `${a.uniqueID}a`,
        x1: "12",
        y1: "2",
        x2: "12",
        y2: "22",
        gradientUnits: "userSpaceOnUse"
      }, [...t[0] || (t[0] = [
        e("stop", { "stop-color": "#4594FF" }, null, -1),
        e("stop", {
          offset: ".604",
          "stop-color": "#357CFC"
        }, null, -1),
        e("stop", {
          offset: "1",
          "stop-color": "#2C6FFA"
        }, null, -1)
      ])], 8, p)
    ])
  ], 10, f);
}
const q = /* @__PURE__ */ u(c, [["render", _]]);
export {
  q as default
};
//# sourceMappingURL=zoom.js.map
